/* eslint-disable no-param-reassign */
import type { ArrayElement } from '@evidia/shared';
import { useEffect } from 'react';
import type { StoreApi, UseBoundStore } from 'zustand';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import type { RouterOutput } from '../utils/trcp';
import { trpc } from '../utils/trcp';

type InviteType = ArrayElement<RouterOutput['schoolInvite']['getUnusedInvites']>;

interface Props {
	invite?: InviteType;
	setInvite: (invite: InviteType) => void;
	clearInvite: () => void;
}

export const useSchoolInvitesStore: UseBoundStore<StoreApi<Props>> = create(
	immer<Props>(set => ({
		invite: undefined,
		setInvite: (invite: InviteType) => {
			set(state => {
				state.invite = invite;
			});
		},
		clearInvite: () => {
			set(state => {
				state.invite = undefined;
			});
		},
	})),
);

export const useFetchInvites = (): { refetch: () => void } => {
	const setInvite = useSchoolInvitesStore(state => state.setInvite);

	const getUnusedInvites = trpc.schoolInvite.getUnusedInvites.useQuery();

	useEffect(() => {
		const item = (getUnusedInvites.data?.[0] as InviteType) ?? undefined;
		setInvite(item);
	}, [getUnusedInvites.data]);

	return {
		refetch: getUnusedInvites.refetch,
	};
};
